<template>
    <div class="h-full">
        <div v-if="!isMobile" class="relative h-full">
            <div v-if="mainStore.loadingGame" class="loading_bg !z-20">
                <Spinner></Spinner>
            </div>
            <div class="live_banner">
                <MerchantMarqueeAnnounce></MerchantMarqueeAnnounce>
                <div v-if="gamesStore.live.ready" class="live_banner_box">
                    <div v-for="(l, index) in gameList" :key="index" class="live_banner_items" :class="index == selected_id ? 'active' : ''">
                        <div class="live_banner_bg" :style="{'background-image' : `url(${getBackgroundImage(index)})`}"></div>
                        <img class="live_banner_char not_allow_select_drag" :src="getGirlImage(index)" :alt="`girl-${index}`" >
                        <div class="live_banner_btn_box" @click="playGame(l[0])">
                            <div class="live_banner_btn_box_aspect_ratio"></div>
                            <img class="live_banner_base not_allow_select_drag" :src="getBaseImage(index)" :alt="`display-${index}`">
                            <img class="live_banner_base_logo_title not_allow_select_drag" :src="getProviderImageBase(index)" :alt="`logo-${index}`">
                            <button type="button" class="category_live_play_btn" :aria-label="$t('play')">
                                <div class="category_live_play_btn_text">{{$t("play")}}</div>
                                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M15.795 11.272L7.795 16.272C6.79593 16.8964 5.5 16.1782 5.5 15L5.5 5.00002C5.5 3.82186 6.79593 3.1036 7.795 3.72802L15.795 8.72802C16.735 9.31552 16.735 10.6845 15.795 11.272Z"></path>
                                    </g>
                                </svg>
                            </button>
                                <img v-if="providerStore.meta['live'][l[0].provider_name] && providerStore.meta['live'][l[0].provider_name].show_vpn == 1" class="vpn_tag select-none" draggable="false" src="/img/icons/new_vpn.webp" alt="vpn_tag" :style="getVpnStyle" />
                        </div>
                        <div v-if="dashboardStore.maintenanceData[l[0].provider_id]" class="live_banner_maintenance">
                            <div class="live_banner_maintenance_aspect_ratio"></div>
                            <div class="maintenance_box">
                                <div class="maintenance_text">
                                    <div class="maintenance_text_1">
                                        <span v-if="dashboardStore.maintenanceData[l[0].provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[l[0].provider_id].start_date, end_date: dashboardStore.maintenanceData[l[0].provider_id].end_date})}}</span>
                                        <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[l[0].provider_id].start_date})}}</span>
                                    </div>
                                    <div class="maintenance_text_2">[{{l[0].provider_name}}]</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="live_btn_section">
                        <div class="container">
                            <div class="flex items-center">
                                <div @click="scrollProvider('left')" class="live_btn_left not_allow_select_drag">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </div>
                                <div class="flex items-center overflow-auto py-[50px] none-scrollbar" ref="providerTabList" style="width: calc(100% - 100px);">
                                    <button @click="selectHandler(index)" v-for="(l, index) in gameList" :aria-label="index" :key="index" type="button" class="live_banner_btn" :class="index == selected_id ? 'active' : ''">
                                        <div class="casino_chip">
                                            <img class="chip not_allow_select_drag" src="/img/live/casino_chip.webp" alt="casino_chip">
                                            <img class="logo not_allow_select_drag" :src="getProviderImage(index)" :alt="`logo-${index}`">
                                        </div>
                                        <div class="casino_label">
                                            <img class="label not_allow_select_drag" src="/img/live/casino_label.webp" alt="casino_label">
                                            <div class="text">{{index}}</div>
                                        </div>
                                        <img v-if="providerStore.meta['live'][l[0].provider_name] && providerStore.meta['live'][l[0].provider_name].show_vpn == 1" class="vpn_tag select-none" draggable="false" src="/img/icons/new_vpn.webp" alt="vpn_tag" :style="getVpnStyle" />
                                    </button>
                                </div>
                                <div @click="scrollProvider('right')" class="live_btn_right not_allow_select_drag">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="live_banner_box">
                    <div class="live_banner_items active !transition-none">
                        <div class="live_banner_bg !transition-none" :style="{'background-image' : `url(${$resolveUrl(`{d}game/games/live/page/SEXY/bg-SEXY.webp`)})`}"></div>
                        <div class="container overflow-hidden relative h-[100%]">
                            <div class="w-[500px] h-[300px] skeleton mx-auto mt-[100px]"></div>
                        </div>
                    </div>
                    <div class="live_btn_section">
                        <div class="container">
                            <div class="flex items-center w-full py-[50px] none-scrollbar mx-auto justify-center md:w-[1000px]">
                                <button v-for="i in 8" :aria-label="$t('casino')" :key="i" type="button" class="live_banner_btn">
                                    <div class="casino_chip">
                                        <img class="chip not_allow_select_drag" src="/img/live/casino_chip.webp" alt="casino_chip">
                                        <div class="logo skeleton h-[50px]"></div>
                                    </div>
                                    <div class="casino_label">
                                        <img class="label not_allow_select_drag" src="/img/live/casino_label.webp" alt="casino_label">
                                        <div class="text skeleton w-1/2 h-[20px]"></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MerchantGameContainerMobile v-if="isMobile" type="live"></MerchantGameContainerMobile>
    </div>
</template>

<script setup>
const {$getCurrency} = useNuxtApp()
const currency = $getCurrency()

const { isMobile } = useDevice();
const router = useRouter();
const config = useRuntimeConfig();
const mainStore = useMainStore();
const gamesStore = useGamesStore();
const userStore = useUserStore();
const dashboardStore = useDashboardStore();
const {$setMeta, $pub, $resolveUrl} = useNuxtApp()
const providerStore = useProviderStore();
const loaded = ref(true);
const route = useRoute();
const localePath = useLocalePath();
const { locale, locales } = useI18n()

const selected_id = ref("");
const selectHandler = (i) => {
    selected_id.value = i;
    route.params.provider = i;
    history.state.current = localePath(`/live/${i}`);
    history.pushState(history.state, "", localePath(`/live/${i}`));
    $setMeta();
}

const readyWatcher = watchEffect(() => {
    if (providerStore.ready && (!userStore.loggedIn || (userStore.loggedIn && dashboardStore.ready))) {
        gamesStore.getGames('live')
        readyWatcher()
    }
}, {
    flush: 'post'
})

watch(() => userStore.loggedIn, () => {
    gamesStore.getGames('live')
})

const providerTabList = ref();
const pos = ref({ top: 0, left: 0, x: 0, y: 0 });
const mouseDownHandler = (e) => {
    providerTabList.value.style.userSelect = 'none';
    pos.value = {
        // The current scroll
        left: providerTabList.value.scrollLeft,
        top: providerTabList.value.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
}
const mouseMoveHandler = (e) => {
    // How far the mouse has been moved
    const dx = e.clientX - pos.value.x;
    const dy = e.clientY - pos.value.y;

    // Scroll the element
    providerTabList.value.scrollTop = pos.value.top - dy;
    providerTabList.value.scrollLeft = pos.value.left - dx;
};
const mouseUpHandler = (e) => {
    providerTabList.value.style.removeProperty('user-select');
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
};
watch(providerTabList, (el) => {
    if (el) {
        providerTabList.value.addEventListener('mousedown', mouseDownHandler);
    }
})

const getBackgroundImage = (p) => {
	if (p) {
        return $resolveUrl(`{d}game/games/live/page/${p.toUpperCase()}/bg-${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getGirlImage = (p) => {
	if (p) {
        return $resolveUrl(`{d}game/games/live/page/${p.toUpperCase()}/girl-${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getBaseImage = (p) => {
	if (p) {
        return $resolveUrl(`{d}game/games/live/page/${p.toUpperCase()}/base.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getProviderImage = (p) => {
	if (p) {
		return $resolveUrl(`{d}game/games/live/page/${p.toUpperCase()}/logo-${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getProviderImageBase = (p) => {
	if (p) {
        return $resolveUrl(`{d}game/games/live/page/${p.toUpperCase()}/base-title.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const playGame = (e) => {
    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore.data.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore.maintenanceData[e.provider_id]
    }
    gamesStore.playGame(game);
}

const gameList = computed(() => {
    if (providerStore.ready && gamesStore.live && gamesStore.live.ready && gamesStore.live.list) {
        let allGames = gamesStore.live.list;
        delete allGames.ALL
        return allGames;
    }
    return {}
})

watch(() => gameList.value, (e) => {
    if (Object.keys(e).length > 0) {
        var getProviderName = route.params.provider;
        if (getProviderName) {
            var matchProvider = Object.keys(e).find(obj => obj == getProviderName);
            if (matchProvider) {
                selectHandler(matchProvider);
            }
        } else {
            selectHandler(Object.keys(e)[0]);
        }
    }
})

const scrollProvider = (e) => {
    if (providerTabList.value) {
        providerTabList.value.style.scrollBehavior = "smooth";
        if (e == 'left') {
            if (providerTabList.value.scrollLeft <= 100) {
                providerTabList.value.scrollLeft = 0;
            } else {
                providerTabList.value.scrollLeft += -100;
            }
        } else if (e == 'right') {
            var ownWidth = providerTabList.value.clientWidth;
            var scrollWidth = providerTabList.value.scrollWidth;
            if (providerTabList.value.scrollLeft <= (scrollWidth - ownWidth)) {
                providerTabList.value.scrollLeft += 100;
            }
        }
        providerTabList.value.style.scrollBehavior = "unset";
    }
}

const getVpnStyle = computed(() => {    
    return {
         background: mainStore.vpn_tag_color,
         padding:'3px'
    }
})
</script>

<style scoped>
.live_banner {
    min-height: 570px;
    height: 100%;
    position: relative;
}
.live_banner_box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.live_banner_items {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.5s;
}
.live_banner_items.active {
    opacity: 1;
    z-index: 2;
}
.live_banner_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.2);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 1s;
}
.active .live_banner_bg {
    transform: translate(-50%, -50%) scale(1);
}

.live_banner_char {
    height: 90%;
    bottom: 0;
    transition: all 0.5s;
    position: absolute;
    transform: scale(2);
    font-size: 12px;
    color: #fff;
}
.active .live_banner_char {
    transform: scale(1);
}
.live_banner_items:nth-child(odd) .live_banner_char {
    right: 25%;
}
.live_banner_items:nth-child(even) .live_banner_char {
    left: 25%;
}


.live_banner_btn_box {
    width: 15%;
    top: 15%;
    position: absolute;
    transform: scale(2);
    transition: all 0.5s;
    cursor: pointer;
}

.live_banner_btn_box .live_banner_btn_box_aspect_ratio {
    width: 100%;
    padding-top: 100%;
}

.isDesktop .live_banner_btn_box:hover {
    animation: enlarge .5s ease-in-out infinite alternate;
}
@keyframes enlarge {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.1);
    }
}
.active .live_banner_btn_box {
    transform: scale(1);
}

.live_banner_items:nth-child(odd) .live_banner_btn_box {
    left: 25%;
}
.live_banner_items:nth-child(even) .live_banner_btn_box {
    right: 25%;
}

.live_banner_base {
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    transition: 0.3s ease-in-out;
    animation: baseLogo .5s ease-in-out infinite alternate;
    filter: brightness(1) saturate(1) drop-shadow(0 2px 3px rgba(0,0,0,.25)) drop-shadow(0 4px 6px rgba(0,0,0,.25));
}

.not_allow_select_drag {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.isDesktop .live_banner_btn_box:hover .live_banner_base{
    animation: unset;
}

@keyframes baseLogo {
    /* 0% {
        filter: brightness(1) saturate(1) drop-shadow(0 2px 3px rgba(0,0,0,.25)) drop-shadow(0 4px 6px rgba(0,0,0,.25));
    }
    100% {
        filter: brightness(1.2) saturate(1.2) drop-shadow(0 2px 3px rgba(0,0,0,.25)) drop-shadow(0 4px 6px rgba(0,0,0,.25));
    } */
    0% {
        filter: brightness(1);
    }
    100% {
        filter: brightness(1.5);
    }
}

.live_banner_play_btn {
    height: 13%;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
}
.live_banner_play_btn img {
    height: 100%;
}

.live_btn_section {
    position: absolute;
    z-index: 3;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
}

.live_banner_btn {
    width: 100px;
    margin: 10px;
    filter: grayscale(1);
    transition: all 0.3s;
    flex-shrink: 0;
    position: relative;
}

.isDesktop .live_banner_btn:hover {
    filter: grayscale(0);
}

.live_banner_btn.active {
    filter: grayscale(0);
    transform: scale(1.2);
}

.live_banner_btn .casino_chip {
    position: relative;
    transition: all 0.8s;
    z-index: 1;
}

.isDesktop .live_banner_btn:hover .casino_chip {
    transform: rotateY(360deg);
}

.live_banner_btn.active .casino_chip {
    transform: rotateY(360deg);
}

.casino_chip .chip {
    width: 120px;
    margin: 0 auto;
}

.casino_chip .logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    max-height: 100%;
    font-size: 12px;
    color: #fff;
}

.casino_label {
    position: relative;
    z-index:21111;
    transform: rotateY(0deg);
}
.casino_label .label {
    width: 150px;
    margin-top: -35px;
}

.casino_label .text {
    font-weight: 700;
    font-size: 12px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.live_btn_left {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
    height: 100px;
    margin-right: 10px;
}

.live_btn_right {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
    height: 100px;
    margin-left: 10px;
    cursor: pointer;
}

.live_btn_left svg,
.live_btn_right svg {
    width: 20px;
}

.live_btn_left svg path,
.live_btn_right svg path {
    fill: #fff;
}

@media (max-width: 1920px) {
    .live_banner_items {
        width: 1920px;
    }
}

@media (max-width: 1800px) {
    .live_btn_section {
        width: 100%;
    }
}

.live_banner_maintenance {
    width: 15%;
    top: 15%;
    position: absolute;
    cursor: default;
}

.live_banner_items:nth-child(odd) .live_banner_maintenance {
    left: 25%;
}
.live_banner_items:nth-child(even) .live_banner_maintenance {
    right: 25%;
}

.live_banner_maintenance .live_banner_maintenance_aspect_ratio {
    width: 100%;
    padding-top: 100%;
}

.vpn_tag {
	width: 25px;
	position: absolute;
	top: -2px;
	right: -10px;
}

.live_banner_base_logo_title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: 0.3s ease-in-out;
    animation: baseLogo .5s ease-in-out infinite alternate;
    filter: brightness(1) saturate(1) drop-shadow(0 2px 3px rgba(0,0,0,.25)) drop-shadow(0 4px 6px rgba(0,0,0,.25));
}
</style>